var singlePurchase = document.querySelector('.product-page-add');
var currantVariantId;
if(singlePurchase){
  currantVariantId = singlePurchase.dataset.purchaseId;
}
var currentPrice;

// variant button selectors

if(document.querySelector('.variant-buttons')){
   var variants = document.querySelectorAll('.variant-buttons .badge');
   variants.forEach( variant => {
     variant.addEventListener('click', () =>{
        if(!variant.classList.contains('current')){
          variants.forEach( variant => variant.classList.remove('current'));
          variant.classList.add('current');
          currentVariant = variant.dataset.variantId;
          currentPrice = variant.dataset.variantPrice;
          let currentUnitPrice = null;
          if(variant.dataset.unitPrice) currentUnitPrice = variant.dataset.unitPrice
          updateVariant(currentPrice, currentVariant, currentUnitPrice);
          changeToImage(currentVariant)
        }
     });
  });
}

// variant dropdown selectors

function dropdownVariants(recentlyChanged){
  var currentSelection = [];
  // build an array of currently selected options
  var optionDropdowns = document.querySelectorAll('.product-option-dropdown').forEach( select => {
    currentSelection.push(select.value);
  });
  var data = JSON.parse(document.querySelector('#variant-json').textContent);
  var matchingVariant = false;
  var matchingVariantPrice;
  var matchingVariantStock;
  data.forEach(variant => {
    var variantOptions = variant.options;
    var isEqual = (variantOptions.length === currentSelection.length) && (variantOptions.every(val => currentSelection.includes(val)));
    if(isEqual){
      matchingVariant = variant.variant;
      matchingVariantPrice = variant.price;
      matchingVariantStock = variant.stock;
    }
  });
  if(matchingVariant && matchingVariantStock > 0){
    singlePurchase.classList.remove('disabled');
    updateVariant(matchingVariantPrice, matchingVariant);
  } else {
    singlePurchase.classList.add('disabled');
    singlePurchase.innerHTML = `Out of stock`;
  }
}

if(document.querySelector('#variant-json')){
  // first run
  document.querySelectorAll('.product-option-dropdown').forEach( select => {
    select.addEventListener('change', (e) => {
       let recentlyChanged = e.currentTarget.value;                   
       dropdownVariants(recentlyChanged);
    });
  });
}

// gestures
let pageWidth = window.innerWidth || document.body.clientWidth;
let treshold = Math.max(1,Math.floor(0.01 * (pageWidth)));
let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;
const limit = Math.tan(45 * 1.5 / 180 * Math.PI);
const gestureZone = document.querySelector('.product-image-large');

// change product image from thumbnails
if(document.querySelector('.product-page-thumbnails')){
  document.querySelector('.product-page-thumbnails').addEventListener('click', e => {
    if(e.target.dataset.productImage){
      changeToImage(e.target.dataset.imageVariant)
    }
  })
  
  // arrow events
  document.querySelector('#gallery-left').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    // get previous image
    let currentImage = document.querySelector('.product-page-thumbnails img.current');
    if(currentImage.previousElementSibling){
      currentImage.previousElementSibling.click();
    } else {
     // get last one
      currentImage.parentElement.lastElementChild.click();
    }
  })
  
  document.querySelector('#gallery-right').addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    // get next image
    let currentImage = document.querySelector('.product-page-thumbnails img.current');   
    if(currentImage.nextElementSibling){
      currentImage.nextElementSibling.click();
    } else {
     // get last one
      currentImage.parentElement.firstElementChild.click();
    }
   })

  // gestures

  gestureZone.addEventListener('touchstart', function(event) {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
  }, false);

  gestureZone.addEventListener('touchend', function(event) {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesture(event);
  }, false);

  function handleGesture(e) {
      let x = touchendX - touchstartX;
      let y = touchendY - touchstartY;
      let xy = Math.abs(x / y);
      let yx = Math.abs(y / x);
      if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
          if (yx <= limit) {
              if (x < 0) {
                  document.querySelector('#gallery-right').click();
              } else {
                  document.querySelector('#gallery-left').click();
              }
          }
      }
  }
}

function changeToImage(id){
  let thumbnailImage = document.querySelector(`.product-page-thumbnails img[data-image-variant="${id}"]`);
  let mainImage = document.querySelector('.product-page-image');
  document.querySelectorAll('.product-page-thumbnails img').forEach(thumbnail => thumbnail.classList.remove('current'));
  
  if(thumbnailImage){
    thumbnailImage.classList.add('current');
    mainImage.src = thumbnailImage.src;
    mainImage.src = thumbnailImage.dataset.productImage;
    // work out how far to scroll by getting the index of the thumbnail and multiplying by width + margin
    let galleryContainer = document.querySelector('.product-page-thumbnails');
    let scrollWidth = galleryContainer.scrollWidth;
    let elementCount = [...galleryContainer.children].findIndex((img) => img === thumbnailImage);
    
    let scrollTarget = elementCount * (thumbnailImage.offsetWidth + 10);
    galleryContainer.scrollTo(scrollTarget, 0);
  }
}

// update price and button on variant change

function updateVariant(price, id, unitPrice){
  document.querySelector('.current-price').textContent = price;
  if(unitPrice) document.querySelector('.unit-price').textContent = unitPrice;
  singlePurchase.dataset.purchaseId = id;
  // add price to data attribute
  let pricebox_element = document.querySelector('.product-page-pricebox');
  pricebox_element.setAttribute('data-price', price.replace(`${currentCurrency}`,''));
  // change the slider
  if(typeof productSlider !== 'undefined'){
    if(productSlider){
      var varientSlideNumber = false;
      document.querySelectorAll('.product-page-images .glide__slide').forEach(slide => {
        // look for a slide image that matches variant
        if(slide.dataset.imageVariant == id){
          varientSlideNumber = parseInt(slide.dataset.slideNumber);
        }
      });
      // if match was found, slide to it
      if(varientSlideNumber){
        productSlider.go('=' + varientSlideNumber);
        productSlider.pause();
      }
    }
  }

  // try to fudge price
  fudge_pricebox();
}

// quantity controls

if(document.querySelector('.product-page-quantity-selection')){
  var adjustment = document.querySelectorAll('.product-page-quantity-selection');
    adjustment.forEach(variantQuantity => {
      variantQuantity.addEventListener('click', (e) => { 
      let quantityInput = variantQuantity.querySelector('.quantity-number');
      var currentValue = parseInt(quantityInput.value);
      var clicked = e.target.classList;
      var newValue;
      switch( true ){
        case clicked.contains('quantity-minus'):
          quantityInput.value = Math.max(currentValue - 1, 0);
          newValue = quantityInput.value;
          break;
        case clicked.contains('quantity-plus'):
          quantityInput.value = currentValue + 1;
          newValue = quantityInput.value;
          break;
      }
      fudge_pricebox();
    });
  });
}

// add to cart function

let isLandingPage = document.querySelector('#welcome-kit');

if(singlePurchase){
  singlePurchase.addEventListener('click', e =>{
     let originalText = singlePurchase.textContent;
     var quantity = document.querySelector('.product-page-quantity-selection .quantity-number').value;
     singlePurchase.textContent = 'Adding…';
     cartAdd(singlePurchase.dataset.purchaseId ,quantity).then((response) => {
       if(response.status == 422){
         button.textContent = 'Not enough stock';
         button.style.backgroundColor = "red";
       } else {
          return updateCart();
       }
     })
     .then( ()=> {
       if(!isLandingPage){
         singlePurchase.textContent = originalText;
         toggleElement(cartDrawer, e);
       } else {
         document.querySelector('#checkout').click();
       }
     });
  });
}

// scroll to reviews
if(document.getElementById('badge-ribbon') && document.getElementById('ReviewsWidget')){
  document.getElementById('badge-ribbon').addEventListener('click', () => {
    document.getElementById('ReviewsWidget').parentElement.scrollIntoView({ behavior: 'smooth'});
  });
}

// out of stock notification popup

if(document.querySelector('.stock-notification')){
  document.querySelector('.stock-notification').addEventListener('click', e => {
     var button = e.target
     
    let data = {
       message: button.dataset.message,
       product: button.dataset.product,
       button: 'Notify me',
       image: button.dataset.image
     }
     stockForm.style.opacity = '1'
     populateEmailPopup(data, e)
  })                                           
}

// tabs functionality

var isMediaSmall = window.matchMedia('(max-width: 39.9375em)');

var tabsHaveMoved = false;
var tabContainer = document.querySelector('.tab-texts-container');

if(tabContainer){
  document.querySelector('.product-tabs-list').addEventListener('click', (e) => {
    var clickedTab = e.target;
    var clickedTabNumber = e.target.dataset.tab;
    if(clickedTab.classList.contains('product-tab-heading')){
      // on desktop, move tabs back responsivelly if moved for mobile layout
      if(!isMediaSmall.matches && tabsHaveMoved == true){
        document.querySelector('#desktop-tabs-location').appendChild(tabContainer);
        tabsHaveMoved = false;
      }
      if(!clickedTab.classList.contains('open')){
        document.querySelectorAll('.product-tab-heading').forEach( tab => {
          if(tab == clickedTab){
            tab.classList.add('open');
            if(isMediaSmall.matches){
              tab.parentNode.insertBefore(tabContainer, tab.nextSibling);
              const y = tab.getBoundingClientRect().top + window.pageYOffset - 160;
              window.scrollTo({top: y, behavior: 'smooth'});
              tabsHaveMoved = true;
            }
          } else {
            tab.classList.remove('open');
          }
        });
        // find the tab content and show it
        document.querySelectorAll('.tab-content').forEach( tabContent => {
          if(tabContent.dataset.tab == clickedTabNumber){
            tabContent.classList.add('open');
          } else {
            tabContent.classList.remove('open');
          }
        });
      }
    }
  });
}

// Ingredients modal popup (optional) – installed mainly for welcome-kit page

document.querySelectorAll('#toggle-product-ingredients-modal, .toggle-product-ingredients-popup').forEach(button => {
  button.addEventListener('click', (e) => {
    toggleElement(document.querySelector('#product-ingedients-modal'), e);
    console.log(e.target.id);
  })
})

  

// Delivery Window Calculator

// first run

deliveryTimer();

addEventListener('DOMContentLoaded', () => {
  fudge_pricebox();
});

// update every minute

setInterval(function () {
  deliveryTimer();
}, 60 * 1000);

function deliveryTimer() {
  // contains final data
  var deliveryContent = {};

  var documentDay = document.querySelector('.delivery-prompt .day');
  var documentWindow = document.querySelector('.delivery-prompt .window');

  // date object

  var now = new Date();
  var currentDay = now.getDay();
  var deliveryDeadline = new Date().setHours(14, 00, 00);

  // relative dates
  var tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
  var dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2));
  var inThreeDays = new Date(new Date().setDate(new Date().getDate() + 3));

  var mondayDispatch = function () {
    deliveryContent.deliveryDay = 'Tuesday';
    deliveryContent.deadlineWindow = ' Order before Monday at 2pm';

    var nextTuesday = new Date();
    nextTuesday.setDate(
      nextTuesday.getDate() + ((2 + 7 - nextTuesday.getDay()) % 7)
    );

    var nextWednesday = new Date();
    nextWednesday.setDate(
      nextWednesday.getDate() + ((3 + 7 - nextWednesday.getDay()) % 7)
    );
  };

  // is it before 2pm
  if (now < deliveryDeadline) {
    // is it Monday – Friday
    if (currentDay > 0 && currentDay < 6) {
      //deliveryDeadline is today before 2pm, deliveryWindow is tomorrow

      let deadline = (deliveryDeadline - now) / 1000 / 60 / 60; // in hours
      let deadlineRemainder = 60 * (deadline - Math.floor(deadline)); // in minutes

      deliveryContent.deliveryDay = new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
      }).format(tomorrow);
      deliveryContent.deadlineWindow =
        ' Order within ' +
        Math.floor(deadline) +
        ' hrs ' +
        Math.floor(deadlineRemainder) +
        ' min';
    } else {
      // it's a Saturday or Sunday before 2pm
      //deliveryDeadline is Monday 2pm, deliveryWindow is Tuesday

      mondayDispatch();
    }

    // it's after 2pm
  } else {
    // is it Monday – Thursday
    if (currentDay > 0 && currentDay < 5) {
      let tomorrow2pm = new Date(
        new Date().setDate(new Date().getDate() + 1)
      ).setHours(14, 00, 00);
      var dayAfterTomorrow = new Date(
        new Date().setDate(new Date().getDate() + 2)
      );

      // deliveryDeadline tomrrow before 2pm, deliveryWindow is in 2 days

      let deadline = (tomorrow2pm - now) / 1000 / 60 / 60; // in hours
      let deadlineRemainder = 60 * (deadline - Math.floor(deadline)); // in minutes

      deliveryContent.deliveryDay = new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
      }).format(dayAfterTomorrow);
      deliveryContent.deadlineWindow =
        ' Order within ' +
        Math.floor(deadline) +
        ' hrs ' +
        Math.floor(deadlineRemainder) +
        ' min';
    } else {
      // it's after 2pm on Friday, Saturday or Sunday
      //deliveryDeadline is Monday 2pm, deliveryWindow is Tuesday
      deliveryContent.deliveryDay = 'Tuesday';
      deliveryContent.deadlineWindow = ' Order before Monday at 2pm';

      mondayDispatch();
    }
  }

  if (documentDay && documentWindow) {
    documentDay.textContent = deliveryContent.deliveryDay;
    documentWindow.textContent = deliveryContent.deadlineWindow;
  }
}

let cached_pricebox_deals_response_text;
async function fudge_pricebox() {

    // get deals
    if (!cached_pricebox_deals_response_text) {
      let pricebox_deals_response = await fetch('/apps/deals/all_deals.php');
      cached_pricebox_deals_response_text = await pricebox_deals_response.text()
    }
    let deals = JSON.parse(cached_pricebox_deals_response_text);
    
    // fix deals structure
    deals.forEach(deal => {
      deal.products.forEach(product => {
        let product_parts = product.id.split('/');
        product.id = product_parts[product_parts.length-1];
      });
    });
  
    let pricebox_element = document.querySelector('.product-page-pricebox');
    let price_element = pricebox_element.querySelector('.current-price .sale') ?? pricebox_element.querySelector('.current-price');
    let del_element = pricebox_element.querySelector('.pricing-element-1 del');
    let upsell_element = pricebox_element.querySelector('.product-delivery-info');
    let product_id = pricebox_element.getAttribute('data-product-id');
  
    let quantity = 0;
    let servings = 0;
    for (let variant_element of document.querySelectorAll('.variant-container')) {
      let variant_quantity = Math.max(Number(variant_element.querySelector('.quantity-number').value), 0);
      let variant_serving_size = Number(variant_element.querySelector('span').textContent.split(' of ')[1] ?? 0);
      quantity += variant_quantity;
      servings += variant_quantity * variant_serving_size;
    }

    // spoof quantity one otherwise it's silly
    quantity = Math.max(quantity, 1);

    // check to see if servings/boxes are active
    if (quantity && !servings) servings = null;

    // first run
    if (!pricebox_element.hasAttribute('data-price')) {
        pricebox_element.setAttribute('data-price', price_element.textContent.replace(',','.').replace(`${currentCurrency}`,''));
        if (del_element) {
          pricebox_element.setAttribute('data-presale-price', del_element.textContent.replace(',','.').replace(`${currentCurrency}`,'').trim());
        }
    }
  
    let price = Number(pricebox_element.getAttribute('data-price'));
    let presale_price = Number(pricebox_element.getAttribute('data-presale-price'));

    // get subelements and attribute values
    let true_price = 0;
    let undiscounted_price = 0;

    function add_line_item(discount_ratio = 1, discount_text = '', max = false) {
            
        // update price
        true_price += price * discount_ratio;
        undiscounted_price += (presale_price || price);
            
        // update dom
        if (undiscounted_price !== true_price) {
            if (!del_element) {

                // upgrade dom to sale layout
                let container = price_element;
                container.textContent = '';
                del_element = document.createElement('del');
                price_element = document.createElement('span');
                price_element.classList.add('sale');
                container.append(price_element, del_element);
            }
            del_element.textContent = currentCurrency + fix_number(undiscounted_price);
          
        } else if (del_element) {

            // revert dom layout
            del_element.remove();
            del_element = undefined;
            price_element.remove();
            price_element = pricebox_element.querySelector('.current-price');
        }

        price_element.textContent = currentCurrency + fix_number(true_price);
    
        // update upsell
        if (discount_text) upsell_element.textContent = discount_text;

    }
  
    // find deal and create item counts (instead of groups like normal)
    let item_counts = [0];
    let deal = deals.find(deal => deal.products.some(product => product.id === product_id));
    if (deal) {

        // sort into groups/counts
        let quantity_to_add = quantity;
        while (quantity_to_add--) {

            found_item_group = false
            
            if (
                (deal.type == 'stacking' || item_counts[item_counts.length-1] < deal.product_count)   // either stacking (so no limit) or below limit
            ) {
                item_counts[item_counts.length-1]++;
                found_item_group = true;
            }

            // add into new group if none found
            if (!found_item_group) {
              item_counts.push(1);
            }
        }

        // calculate discounts
        item_counts.forEach(item_count => {

            for (let item_index = 0; item_index < item_count; item_index++) {

                // set discount ratio and text (for applied deals only) if group reached product count
                let discount_ratio = 1;
                let discount_text = '';
                let max = false;
                if (item_count >= deal.product_count) {
                
                    if (deal.type == 'bogof') {

                        // no of items discounted minus position from start of group
                        discount_ratio = 1 - Math.min(Math.max(deal.discount - item_index, 0), 1);
                    
                        // bogof active so show deal name
                        discount_text = deal.friendly_type;
                    
                        max = true;

                    } else if (deal.type == 'stacking') {

                        // set discount based off deal discount, stacking limit, group count
                        discount_ratio = 1 - (deal.discount * Math.min(item_count, deal.stacking_limit));
                    
                    }
                }

                // set generic and unapplied discount text
                if (!discount_text) {
                
                    if (deal.type == 'bogof') {

                        // buy one get one free
                        if (deal.product_count == 2 && deal.discount == 1) {
                            discount_text = 'Add 1 for free?';
                        
                        // buy one get one half price
                        } else if (deal.product_count == 2 && deal.discount == 0.5) {
                            discount_text = 'Buy 1 get 1 half price ';
                        
                        // 3 for 2
                        } else if (deal.product_count == 3 && deal.discount == 1) {
                            discount_text = 'Add more, get 3 for 2';
                        }

                    } else if (deal.type == 'stacking') {

                        // round to .5s via *2)/2
                        if (item_count >= deal.stacking_limit) {
                            discount_text = (Math.trunc(0.0001 + (1-discount_ratio)*100*2)/2)+'% discount applied';
                            max = true;
                        } else {
                            discount_text = 'Buy '+(item_count+1)+', get '+(Math.trunc(0.0001 + deal.discount * 100 * (item_count + 1) * 2) / 2)+'% off';
                        }
                    }
                }
                
                // add to line items
                add_line_item(discount_ratio, discount_text, max);
            }
        });
    } else {

        // add remaining (ungrouped) line items - stripped out version of above
        for (let i = 0; i < quantity; i++) {
            add_line_item();
        }
    }

    if (servings !== null) {
      let type = pricebox_element.querySelector('.unit-price-1').textContent.includes('box') ? ' box' : ' tube';
      pricebox_element.querySelector('.unit-price-1').textContent = quantity + type + (quantity > 1 ? type == ' box' ? 'es' : 's' : '') + ' / ' + servings + ' servings';
      pricebox_element.querySelector('.unit-price-2').textContent = currentCurrency + fix_number(true_price / servings) + ' per unit';
    }
}